import React, { useContext, useRef, useState } from "react";
export const ViewsContext = React.createContext({
    views: {},
    selectedView: null,
    addView: (_view) => { },
    selectView: (_viewId) => { },
    directionRef: null,
    canvasRef: null,
});
export const ViewsContextProvider = ({ children, }) => {
    const [views, setViews] = useState({});
    const [selectedView, setSelectedView] = useState(null);
    const directionRef = useRef("up");
    const canvasRef = useRef({ height: null, width: null });
    const addView = (view) => {
        setViews((previousViews) => (Object.assign(Object.assign({}, previousViews), { [view.id]: view })));
    };
    const selectView = (viewId) => {
        setSelectedView(views[viewId]);
    };
    return (React.createElement(ViewsContext.Provider, { value: {
            views,
            selectedView,
            addView,
            selectView,
            directionRef,
            canvasRef,
        } }, children));
};
export const useCesiumViews = () => useContext(ViewsContext);
//# sourceMappingURL=ViewsContext.js.map